import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, memo } from "react";
const SvgLateNightWhite = ({ title, titleId, ...props }, ref)=>/*#__PURE__*/ jsxs("svg", {
        viewBox: "0 0 64 64",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        role: "img",
        ref: ref,
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ jsx("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ jsx("path", {
                d: "M32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32C0 14.3269 14.3269 0 32 0ZM32 2.28613C15.5893 2.28613 2.28613 15.5893 2.28613 32C2.28613 48.4107 15.5893 61.7139 32 61.7139C48.4107 61.7139 61.7139 48.4107 61.7139 32C61.7139 15.5893 48.4107 2.28613 32 2.28613Z",
                fill: "url(#paint0_linear_4_290)"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M26 36.2002L20.5547 42.5H26V45.5H17V42.7998L22.4453 36.5H17V33.5H26V36.2002ZM36.5 28.7002L31.0547 35H36.5V38H27.5V35.2998L32.9453 29H27.5V26H36.5V28.7002ZM47 18.5V21.2002L41.5547 27.5H47V30.5H38V27.7998L43.4453 21.5H38V18.5H47Z",
                fill: "white"
            }),
            /*#__PURE__*/ jsx("defs", {
                children: /*#__PURE__*/ jsxs("linearGradient", {
                    id: "paint0_linear_4_290",
                    x1: -32,
                    y1: 32,
                    x2: 32,
                    y2: 96,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ jsx("stop", {
                            stopColor: "#FFEEB1"
                        }),
                        /*#__PURE__*/ jsx("stop", {
                            offset: 1,
                            stopColor: "#BA4401"
                        })
                    ]
                })
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ forwardRef(SvgLateNightWhite);
const Memo = /*#__PURE__*/ memo(ForwardRef);
const LateNightWhite = Memo;
export { LateNightWhite as default };
